import { useContext } from 'react';
import ActionDialogContext from '../contexts/actionDialog';

const useActionDialog = () => useContext(ActionDialogContext);

export default useActionDialog;
